import { render, staticRenderFns } from "./precent1.vue?vue&type=template&id=44c14d0e&scoped=true"
import script from "./precent1.vue?vue&type=script&lang=js"
export * from "./precent1.vue?vue&type=script&lang=js"
import style0 from "./precent1.vue?vue&type=style&index=0&id=44c14d0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c14d0e",
  null
  
)

export default component.exports